import watchDeleteEmployeesSaga from './deleteEmployeeSaga';
import watchFetchEmployeesSaga from './fetchEmployeesSaga';
import watchInviteEmployeesSaga from './inviteEmployeesSaga';
import watchModifyEmployeesSaga from './modifyEmployeeSaga';

const companySettingSagas = [watchDeleteEmployeesSaga(), watchFetchEmployeesSaga(), watchModifyEmployeesSaga(), watchInviteEmployeesSaga()];
export default companySettingSagas;
